import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { EventManager } from "../../../core";
import { DateUtil } from "../../util/date.util";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "filter-start-end-date",
  templateUrl: "./filter-start-end-date.html",
  styleUrls: ["./filter-start-end-date.scss"],
})
export class FilterStartEndDateComponent  implements OnInit, OnChanges, OnDestroy {
  @Input("title") title: any;
  @Input("titleStart") titleStart: any;
  @Input("titleEnd") titleEnd: any;
  @Input("startDate") startDate: number;
  @Input("endDate") endDate: number;
  @Input("isDefaultData") isDefaultData: boolean = true;
  @Input("isValidated") isValidated: boolean = false;
  @Input("isValidated") isRequired: boolean = false;
  @Input("isNoFuture") isNoFuture: boolean = false;
  @Input("isNoPast") isNoPast: boolean = false;
  @Input("isDisabledStart") isDisabledStart: boolean = false;
  @Input("isDisabledStart") isDisabledEnd: boolean = false;
  formDate: FormGroup = this.formBuilder.group({
    startDate: [null],
    endDate: [null],
  });
  format: string = 'dd/MM/yyyy';
  subscriptions: Subscription[];
  checkChange$ = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    public eventManager: EventManager
  ) {
  }
  ngOnInit() {
    this.subscriptions = [
      this.checkChange$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.checkChange();}),
      ...[
        this.eventManager.subscribe("reset-data-filter", (res) => {
          this.setDefault();
        }),
        this.formDate.get("startDate").valueChanges.subscribe((val) => {
          let startDate;
          if (typeof val === "string") {
            startDate = val ? DateUtil.revertDate(val+ ', 00:00:00', this.format + ', hh:mm:ss') : null;
          } else {
            startDate = new Date(val);
          }
          this.startDate = startDate ? startDate.getTime() : null;
          this.checkChange$.next(true);
        }),
        this.formDate.get("endDate").valueChanges.subscribe((val) => {
          let endDate;
          if (typeof val === "string") {
            endDate = val ? DateUtil.revertDate(val+ ', 23:59:59', this.format + ', hh:mm:ss') : null;
          } else {
            endDate = new Date(val);
          }
          this.endDate = endDate ? endDate.getTime() : null;
          this.checkChange$.next(true);
        }),
      ],
    ];
    //  set default date
    this.setDefault();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.startDate && changes.startDate.currentValue) {
      const startDate = new Date(changes.startDate.currentValue).getTime();
      if (!DateUtil.isInvalidDate(startDate)) {
        this.startDate = startDate;
        this.setDate("startDate", this.startDate);
      }
      
    }
    if (changes.endDate && changes.endDate.currentValue) {
      const endDate = new Date(changes.endDate.currentValue).getTime();
      if (!DateUtil.isInvalidDate(endDate)) {
        this.endDate = endDate;
        this.setDate("endDate", this.endDate);
      }
    }
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  checkChange(): void {
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.emitInputDate('startDate', DateUtil.parseDate(this.endDate, this.format));
      return;
    }
    this.eventManager.broadcast({
      name: "change-filter-start-end-date",
      content: this.emitData(),
    });
  }
  setNull() {
    this.startDate = null;
    this.setDate('startDate', null);
    this.endDate = null;
    this.setDate('endDate', null);
  }
  setDefault() {
    if (this.isDefaultData && !this.startDate && !this.endDate) {
      let date = new Date();
      this.endDate = date.valueOf();
      this.setDate('endDate', date);
      this.startDate = new Date(
        date.getMonth() + 1 + "/" + 1 + "/" + date.getFullYear()
      ).valueOf();
      this.setDate(
        'startDate',
        new Date(date.getMonth() + 1 + "/" + 1 + "/" + date.getFullYear())
      );
    } else {
      if (!this.startDate && !this.endDate) {
        this.setNull();
      } else {
        this.setDate('startDate', this.startDate);
        this.setDate('endDate', this.endDate);
      }
    }
  }
  setDate(field, date): void {
    // Set today date using the setValue function
    this.formDate.patchValue({
      [field]: date ? DateUtil.parseDate(date, this.format) : undefined,
    });
    this.checkValidDate(field);
  }
  emitInputDate(field, text) {
    this.formDate.patchValue({
      [field]: text,
    });
    this.checkValidDate(field);
  }
  checkValidDate(fieldInput) {
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      if (fieldInput === 'startDate') {
        this.setDate('endDate', this.startDate);
      } else {
        this.setDate('startDate', this.endDate);
      }
    }
  }
  emitData() {
    return {
      startDate: this.startDate,
      endDate: DateUtil.revertDate( DateUtil.parseDate(this.endDate, 'dd/MM/yyyy') + ', 23:59:59', 'dd/MM/yyyy, hh:mm:ss').getTime(),
    };
  }
  startDateNow() {
    document.getElementById("start-date").classList.toggle("active");
  }
  endDateNow() {
    document.getElementById("end-date").classList.toggle("active");
  }
  
}
